import actions from './actions';
import { createReducer } from '../../../../../../helpers/reducer';

// ------------------------------
// Initial State
// ------------------------------
const initState = {
  invoice: null,
  editInvoiceForm: null,
  isEdit: false,
  loading: false,
};

// ------------------------------
// Action Handlers
// ------------------------------
function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data } = payload;
  const invoice = data;

  return {
    ...state,
    invoice,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

// ------------------------------
// Local util functions
// ------------------------------

// ------------------------------
// Exported reducer function.
// ------------------------------
export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
